import { Link, useLocation } from 'react-router';
import { VisuallyHidden } from '@ircf/ui';
import { portalRoutes } from '@ircf/config';

export function MessageFab({ unread = 0 }: { unread?: number }) {
  const location = useLocation();
  if (location.pathname.startsWith(portalRoutes.messages.path)) return null;

  return (
    <Link
      to={portalRoutes.messages.path}
      data-print-hide="true"
      className="fixed right-4 z-40 flex size-14 items-center justify-center rounded-full bg-performance-green text-near-black shadow-[0_12px_32px_-8px_rgb(168_230_92_/_0.7)] transition-transform duration-200 hover:scale-105 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-warm-white lg:hidden bottom-[calc(5.5rem+env(safe-area-inset-bottom,0px))]"
    >
      <VisuallyHidden>
        Message your trainer{unread > 0 ? `, ${unread} unread` : ''}
      </VisuallyHidden>
      <svg aria-hidden="true" viewBox="0 0 24 24" className="size-6" fill="none">
        <path
          d="M4 6.5A1.5 1.5 0 0 1 5.5 5h13A1.5 1.5 0 0 1 20 6.5v8A1.5 1.5 0 0 1 18.5 16H9l-4 3.5V6.5Z"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinejoin="round"
        />
      </svg>
      {unread > 0 ? (
        <span
          aria-hidden="true"
          className="absolute top-1 right-1 flex min-w-4 items-center justify-center rounded-full bg-near-black px-1 text-[0.6rem] font-semibold text-performance-green"
        >
          {unread > 9 ? '9+' : unread}
        </span>
      ) : null}
    </Link>
  );
}
